export default {
  getParametros({ parametros }) {
    return parametros
  }
}
